import styled from "styled-components";

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 17px;
    h2{
        font-size: 20px;
        color: #141823;
        font-weight: 900;
        text-transform: uppercase;
        margin-right: 16px;
        flex-shrink: 0;
    }
`;
export const HeaderWidget = styled.div`
    background: #FFFFFF;
    border: 1px solid #E7E7E7;
    border-radius: 100px;
    height: 32px;
    padding: 0 16px;
    flex-shrink: 0;
    margin-right: 22px;
    display: flex;
    align-items: center;
    span{
        font-size: 12px;
        color: #747474;
        margin-right: 10px;
    }
    label{
        font-size: 13px;
        font-weight: 700;
        color: #000;
        &:first-of-type{
            margin-right: 10px;
        }
    }
`;
export const Search = styled.div`
    border: 1px #E7E7E7 solid;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex: 1;
    height: 45px;
    padding-left: 5px;
    input[type="text"]{
        flex: 1;
        background-color: transparent;
        border: 0;
        outline: 0;
        font-family: 'Lato';
        font-size: 12px;
        color: #747474;
        padding: 0 7px;
    }
    button{
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border: 0;
        border-left:1px #E7E7E7 solid;
        cursor: pointer;
        background: none;
        outline: 0;
    }
    img{
      width: 20px;
    }
    .clearSpan {
      margin-top: 8px;
      cursor: pointer;
    }
    .clearCancel {
      margin-top: 11px;
      cursor: pointer;
      margin-right: 3px;
    }
`;

export const Cta = styled.button`
    display: inline-flex;
    height: 44px;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #fff;
    font-family: 'Lato';
    font-weight: 900;
    cursor: pointer;
    outline: 0;
    border: 0;
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
    border-radius: 4px;
    background-color: #008CFF;
    margin-left: 13px;
    padding: 0 45px;
    flex-shrink: 0;
    text-transform: uppercase;
`;

export const StatementTimeWrap = styled.div(
  props => `
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
    margin-right: 12px;
  `
);

export const StatementTimeInnerWrap = styled.div(
  props => `
    display: flex;
    border:1px solid ${props.theme.colors.grey.lighte7};
    border-radius: ${props.theme.misc.borderRadius.base};
    padding: ${props.theme.spacing.large.l12} ${props.theme.spacing.large.l20};
    @media (max-width: 768px){
      position:relative;
    }
  `
);

export const FromTimeWrap = styled.div(
  props => `
    display: flex;
    align-items: center;
    cursor: pointer;
  `
);

export const CalendarWrapper = styled.div(
  props => `
    display: flex;
    position: absolute;
    @media (max-width: 768px){
      top:1.2rem;
      left: 0;
    }
  `
)

export const CalendarWrapperFrom = styled(CalendarWrapper)(
  props => `
    margin-left: -21rem;
    @media (max-width: 768px){
      margin-left:0;
    }
  `
)

export const CalendarWrapperTo = styled(CalendarWrapper)(
  props => `
    margin-left: -6rem;
    @media (max-width: 768px){
      margin-left:0;
    }
  `
)

export const FromTimeText = styled.p(
  props => `
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.grey.base};
  `
);

export const FromTimeMainText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    margin-left: ${props.theme.spacing.base};
  `
);

export const TimeBreakDiv = styled.div(
  props => `
    width:1px;
    height: 2rem;
    display: flex;
    margin: 0 ${props.theme.spacing.large.l20};
    transform: rotate(45deg);
  `
)

export const CloseBtn = styled.span`
    width: 20px;
    height: 20px;
    background-color: #008CFF;
    border-radius: 50%;
    //position: absolute;
    display: inline-block;
    top: 18px;
    right: 18px;
    cursor: pointer;
    margin-right: 4px;
    margin-top: 12px;

    &:before,
    &:after {
        //position: absolute;
       // margin-left: 11px;
        content: ' ';
        height: 13px;
        //width: 2px;
        //margin-top: 4px;
        background-color: #fff;
    }
    &:before {
        transform: rotate(45deg);
       // margin-left: 11px;
        content: ' ';
        //height: 15px;
        width: 2px;
       // margin-top: 4px;
        background-color: #fff;
        display: inline-block;
        margin-left: 8px;
        
    }
    &:after {
        transform: rotate(-45deg);
        display: inline-block;
        content: ' ';
        //height: 15px;
        width: 2px;
        //margin-top: 4px;
        background-color: #fff;
        margin-left: -1px;
        margin-top: 4px;
    }
`;